import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BPSpreadTooltipComponent } from './bp-spread-tooltip.component';
import { BPSpreadTooltipDirective } from './bp-spread-tooltip.directive';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    BPSpreadTooltipComponent,
    BPSpreadTooltipDirective
  ],
  imports: [
    CommonModule,
    MatButtonModule
  ],
  exports: [BPSpreadTooltipDirective]
})
export class BPSpreadTooltipModule { }